import {Tooltip, useTheme} from '@mui/material';
import Box from '@mui/material/Box';

import {grey} from '@mui/material/colors';
import {type CageGrowth} from 'client';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import {type ComponentProps} from 'react';
import {useTranslation} from 'react-i18next';

export const GrowthErrorTag = ({
  shortTermGrowthModelStatus,
  boxProps,
}: {
  shortTermGrowthModelStatus: CageGrowth['shortTermGrowthModelStatus'];
  boxProps?: ComponentProps<typeof Box>;
}) => {
  const theme = useTheme();
  const {t} = useTranslation('common');

  if (shortTermGrowthModelStatus === 'ok') {
    return null;
  }

  const tooltipTitle =
    shortTermGrowthModelStatus === 'poor_data' ? 'poorGrowthModelData' : 'missingShortTermGrowthModel';
  const backgroundColor =
    shortTermGrowthModelStatus === 'poor_data' ? theme.palette.warning.light : theme.palette.error.light;

  return (
    <Tooltip title={t(tooltipTitle) ?? ''} arrow sx={{whiteSpace: 'pre-line'}}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          borderRadius: 100,
          textTransform: 'uppercase',
          flexShrink: 0,
          color: grey[900],
          backgroundColor,
          ...boxProps,
        }}
      >
        <PriorityHighIcon
          sx={{
            height: '18px',
            width: '100%',
            padding: '2px',
          }}
        />
      </Box>
    </Tooltip>
  );
};
